var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex alig-items-center hidden-extra-content"},_vm._l((5),function(item,index){return _c('v-sheet',{key:index,staticClass:"pa-1",attrs:{"color":"grey lighten-4 mr-5"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"width":"270px","height":"140px","type":"article"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }